import React, { useEffect, useRef, useState } from "react";
import styles from "./ActionPage.module.scss";
import AddProgramsHeader from "../../../Molecules/Programs/AddProgramsHeader";
import StepsBar from "../../../Molecules/Programs/StepsBar";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFetchProgramById } from "../../../../Hooks/Programs";
import { isEmpty } from "lodash";
import ProgramFirstStep from "../../../Molecules/Programs/ProgramSteps/ProgramFirstStep";
import ProgramSecondStep from "../../../Molecules/Programs/ProgramSteps/ProgramSecondStep";
import ProgramThirdStep from "../../../Molecules/Programs/ProgramSteps/ProgramThirdStep";
import { useToast } from "../../../Molecules/Custom/CustomToaster/Toast";

const ActionPage = () => {
  const step1Ref = useRef();
  const step3Ref = useRef();
  const customizedToast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [step, setStep] = useState(1);
  const [degreeId, setDegreeId] = useState("");
  const [mode, setMode] = useState(location?.state?.mode || "add");

  const {
    data: degree,
    refetch: refetchProgram,
    isLoading: isSingleDegreeLoading,
  } = useFetchProgramById(id);

  useEffect(() => {
    if (!isEmpty(id) || undefined !== id || !id) {
      refetchProgram();
    } else {
      step1Ref.current?.resetForm();
      step3Ref.current?.resetForm();
    }
  }, [id]);

  useEffect(() => {
    if (degreeId) {
      navigate(`/home/programs/edit/${degreeId}`);
    }
  }, [degreeId]);

  const handleNext = async (next) => {
    if (step === 1) {
      if (next) {
        await step1Ref.current?.submitForm();
        if (!step1Ref.current?.isValid) {
          toast.error("Please Fill All Required Fields");
          window.scrollTo(0, 0);
        }
      }
    } else if (step === 2) {
      setStep((prev) => prev + 1);
    } else if (step === 3) {
      if (next) {
        try {
          await step3Ref.current?.submitForm();
          if (!step3Ref.current?.isValid) {
            toast.error("Please Fill All Required Fields");
            window.scrollTo(0, 0);
          }
        } catch (error) {
          console.error("Error submitting form:", error);
        }
      }
    }
  };

  return (
    <div className={styles["action-programs"]}>
      <div className={styles["container"]}>
        <AddProgramsHeader
          step={step}
          handleNextClick={() => handleNext(true)}
          mode={mode}
        />
        <StepsBar step={step} setStep={setStep} />
      </div>{" "}
      <div className={styles["container"]}>
        {1 === step ? (
          <ProgramFirstStep
            ref={step1Ref}
            id={id}
            degree={degree?.data}
            refetchProgram={refetchProgram}
            setDegreeId={setDegreeId}
            degreeId={degreeId}
            isLoading={isSingleDegreeLoading}
            setStep={setStep}
            mode={mode}
          />
        ) : 2 === step ? (
          <ProgramSecondStep
            degreeCurriculumDetails={degree?.data?.degreeCurriculumDetails}
            refetchProgram={refetchProgram}
          />
        ) : (
          <ProgramThirdStep
            ref={step3Ref}
            id={id}
            degree={degree?.data}
            isLoading={isSingleDegreeLoading}
            mode={mode}
          />
        )}
      </div>
    </div>
  );
};

export default ActionPage;
